<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-bind="attrs"
        v-on="on"
        class="language-selector"
      >
        <img :src="currentFlag" width="24" class="mr-2" />
        {{ currentLanguageLabel }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="lang in languages"
        :key="lang.code"
        @click="changeLanguage(lang.code)"
        :class="{ 'selected-language': currentLanguage === lang.code }"
      >
        <v-list-item-avatar tile size="24" class="mr-2">
          <img :src="lang.flag" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ lang.label }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon v-if="currentLanguage === lang.code">
          <v-icon color="primary">mdi-check</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LanguageSelector',
  data() {
    return {
      languages: [
        { 
          code: 'en', 
          label: 'English',
          flag: require('@/assets/Flag_of_the_United_Kingdom.svg')
        },
        { 
          code: 'it', 
          label: 'Italiano',
          flag: require('@/assets/ititalyflag_111732.svg')
        },
        { 
          code: 'de', 
          label: 'Deutsch',
          flag: require('@/assets/Flag_of_Germany.svg')
        }
      ]
    }
  },
  computed: {
    ...mapState('language', ['currentLanguage']),
    currentLanguageLabel() {
      const lang = this.languages.find(l => l.code === this.currentLanguage)
      return lang ? lang.label : 'English'
    },
    currentFlag() {
      const lang = this.languages.find(l => l.code === this.currentLanguage)
      return lang ? lang.flag : this.languages[0].flag
    }
  },
  methods: {
    ...mapActions('language', ['setLanguage']),
    changeLanguage(lang) {
      this.setLanguage(lang)
    }
  }
}
</script>

<style scoped>
.language-selector {
  color: #213A8F;
}

.selected-language {
  background-color: rgba(33, 58, 143, 0.1);
}
</style> 